import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 片流れ屋根ー流れ方向選択ダイアログ
 * 片流れ選択後に表示される
 */
class RoofDirectionSelection extends Dialog {
    info: marietta.webcad.collection.ItemInfoCollection;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'roofDirectionDialog';
      // タイトル
      let title = '';
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '片流れの方向を選択してください'; break;
        default: title = 'Select a Roof Direction'; break;
      }
      let contents = '<div class="dialogRoodDirectionBox">\n';

      // 下
      contents += '<div class="roofDirectionBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofDirectionImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofDirection1.png" alt="">\n`;
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // 上
      contents += '<div class="roofDirectionBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofDirectionImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofDirection2.png" alt="">\n`;
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // 右
      contents += '<div class="roofDirectionBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofDirectionImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofDirection3.png" alt="">\n`;
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // 左
      contents += '<div class="roofDirectionBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofDirectionImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofDirection4.png" alt="">\n`;
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';

      // 注意書き
      contents += '<div class="roofDirectionComment"><span class="jp">※矢印方向は、屋根の下がり方向を表します。</span><span class="en">*Arrowed direction shows the descending direction of the roof.</span></div>\n';

      contents += '</div>';

      const footer = '';

      this.createDialog(id, title, contents, footer);

      document.querySelectorAll(`#${this.viewObj.id} .roofDirectionBtn`).forEach((element) => {
        element.addEventListener('click', this.onSelectRoofDirection);
      });
    }

    /**
     * 屋根の方向が選択された
     */
    onSelectRoofDirection = (e) => {
      e.preventDefault();

      const index = [...document.querySelectorAll(`#${this.viewObj.id} .roofDirectionBtn`)].indexOf(e.currentTarget);

      // 屋根タイプ
      this.info.roof_direction = (index + 1);

      // 作成
      const createdItem = <marietta.webcad.item.Roof>marietta.webcad.WebCADGlobal.itemManager.createItem(this.info);
      // 屋根形状作成
      marietta.webcad.WebCADGlobal.cadAPIManager.getRoof(createdItem.onDrawRoofDesign, createdItem.onRoofApiFailed);
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // ダイアログを閉じる
      this.close();
    }
}

export default RoofDirectionSelection;
